import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import 'react-datepicker/dist/react-datepicker.css';
import JobService from '../../services/JobService';
import CustomerService from '../../services/CustomerService';
import moment from 'moment';
import {
    snakeCaseToTitle,
    promptPriceChangeReason as promptForPriceChangeReason,
    isValidPostcode,
    POSTCODE_FORMAT_ERROR,
} from '../../utils/Helpers';
import AdminCreateJob from './AdminCreateJob';
import CustomerCreateJob from '../Customer/Jobs/CustomerCreateJob';

class JobForm extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.submitButtonRef = React.createRef();
        this.jobService = new JobService();
        this.customerService = new CustomerService();
        const { job } = this.props;

        let customer, contact, contacts;
        if (this.props.buttonText === 'Create' && !this.props.customer_contact) {
            contacts = this.props.customerContacts;
        }

        if (this.props.customers) {
            if (job.customer_id && this.props.customers) {
                customer = this.props.customers.find((el) => el.id === job.customer_id);
            }
            if (this.props.customers.filter((customer) => customer.id === job.customer_id)[0]) {
                contacts = this.props.customers.filter((customer) => customer.id === job.customer_id)[0].contacts;
                if (job.customer_contact_id) {
                    contact = contacts.find((el) => el.id === job.customer_contact_id);
                }
            }
        } else {
            customer = this.props.customer_contact ? this.props.customer_contact.customer : this.props.customer;
            contact = this.props.customer_contact;
        }

        let job_source;
        if (job.job_source_id) {
            job_source = this.props.jobSources.find((el) => el.id === job.job_source_id);
        }

        if (job.service_provider_id) {
            job.service_provider_id = this.props.providers.find((el) => el.id === job.service_provider_id);
        }

        let date_ready;
        if (job.date_ready) {
            date_ready = new Date(job.date_ready);
        }

        let execution_date;
        if (job.execution_date) {
            execution_date = new Date(job.execution_date);
        }

        const jobType = this.props.jobs.find((jobType) => {
            return jobType.id === job.job_type_id;
        });
        let jobTypeName = null;
        if (typeof jobType !== 'undefined') {
            jobTypeName = jobType.name.toLowerCase();
        }

        const firstName =
            job.created_by && job.created_by.trim() !== ''
                ? job.created_by
                : this.props.currentUser && this.props.currentUser.name
                  ? this.props.currentUser.name.trim().split(' ')[0]
                  : 'system'; // fallback if nothing else

        this.state = {
            job_id: job.id || '',
            job_type: jobTypeName,
            customer_id: customer || '',
            customer_contact_id: contact || '',
            department: typeof contact !== 'undefined' ? contact.department : 'Contact not selected',
            job_source_id: job_source || '',
            job_type_id: job.job_type_id || '',
            address_line_1: job.address_line_1 || '',
            address_line_2: job.address_line_2 || '',
            telephone: job.telephone || '',
            postcode: job.postcode || '',
            purchase_order_number: job.purchase_order_number || '',
            purchase_order_total: job.purchase_order_total || '',
            created_by: firstName,
            city: job.city || '',
            sla: job.sla || '',
            description: job.description || '',
            special_requests: job.special_requests || '',
            created_by: firstName,
            admin_notes: job.admin_notes || '',
            os_contact_name: job.os_contact_name || '',
            os_contact_mobile: job.os_contact_mobile || '',
            os_contact_updates: job.os_contact_updates || false,
            quantity: job.quantity || '1',
            extras: '',
            extrasOptions: [],
            jobExtrasOptions: [],
            tyreTypesOptions: [],
            gardeningExtrasOptions: [],
            wasteBagExtrasOptions: [],
            skipHireExtrasOptions: [],
            jobTypeOptions: [],
            date_ready: date_ready || null,
            non_stop: job.non_stop || false,
            two_person_team: job.two_person_team || false,
            selectedExtras: job.job_extras ? job.job_extras : [],
            selectedGardeningExtras: job.gardening_extras || [],
            selectedWasteBagExtras: job.waste_bag_extras || [],
            selectedSkipHireExtras: job.skip_hire_extras || [],
            job_group: job.job_group || '',
            custom_price: job.custom_price || '',
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : '',
            price_quoted: job.price_quoted || false,
            recurring: job.recurring || false,
            manager_review: job.manager_review || false,
            manager_review_reason: job.manager_review_reason || '',
            excluded_from_sla: job.excluded_from_sla || false,
            excluded_from_sla_reason: job.excluded_from_sla_reason || '',
            recurring_interval: job.recurring_interval || '',
            recurring_days: job.recurring_days && job.recurring_days.length > 0 ? job.recurring_days : [[]],
            acceptedFiles: [],
            contacts: contacts,
            errors: {},
            img: '',
            service_provider_id: job.service_provider_id || '',
            loading: false,
            showGardeningExtras: false,
            showWasteBagExtras: false,
            showSkipHireExtras: false,
            rejected_files: {},
            disable_po: false,
            waste_container_identifier: job.waste_container_identifier || '',
            provider_price_quoted: job.provider_price_quoted || false,
            provider_custom_price: job.provider_custom_price || '',
            execution_date: execution_date || null,
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
        };
    }

    componentDidMount() {
        this.handleExtras();

        if (this.state.customer_id) {
            this.loadCustomerData(this.state.customer_id.id);
        }

        const jobTypeLower = this.state.job_type?.toLowerCase() || '';

        this.setState({
            showGardeningExtras: jobTypeLower.includes('void') || jobTypeLower === 'gardening',
            showWasteBagExtras: jobTypeLower === 'waste bag',
            showSkipHireExtras: jobTypeLower === 'skip hire',
        });
    }

    handleJobPrice = (e) => {
        const { name, value } = e.target;
        if (name === 'custom_price') {
            this.setState({
                custom_price_with_vat: +(value * 1.2).toFixed(2),
                custom_price: value,
            });
        } else {
            this.setState({
                custom_price_with_vat: value,
                custom_price: +(value / 1.2).toFixed(2),
            });
        }
    };

    handleProviderJobPrice = (e) => {
        const { name, value } = e.target;
        if (name === 'provider_custom_price') {
            this.setState({
                provider_custom_price_with_vat: +(value * 1.2).toFixed(2),
                provider_custom_price: value,
            });
        } else {
            this.setState({
                provider_custom_price_with_vat: value,
                provider_custom_price: +(value / 1.2).toFixed(2),
            });
        }
    };

    handleChange = (e) => {
        const { name, value, type } = e.target;
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        this.setState(
            {
                [name]: type === 'checkbox' ? !this.state[name] : value,
                errors: errorsObject,
            },
            () => {
                if (name === 'job_type_id') {
                    this.setState({ job_type_id: value });
                    this.handleJobTypeChange(value);
                }
                if (name === 'service_provider_id') {
                    this.setState({
                        service_provider_id: value,
                    });
                }
            }
        );
    };

    handleRecurringDayToggle = (weekIndex, day) => {
        const recurring_days = this.state.recurring_days.map((week_days, index) => {
            if (index !== weekIndex) {
                return week_days;
            }

            return week_days.includes(day) ? week_days.filter((selected) => selected !== day) : [...week_days, day];
        });

        let errorsObject = { ...this.state.errors };
        delete errorsObject.recurring_days;

        this.setState({ recurring_days, errors: errorsObject });
    };

    addRecurringWeek = () => {
        if (this.state.recurring_days.length >= 2) {
            return;
        }

        this.setState({ recurring_days: [...this.state.recurring_days, []] });
    };

    removeRecurringWeek = (weekIndex) => {
        this.setState({
            recurring_days: this.state.recurring_days.filter((_, index) => index !== weekIndex),
        });
    };

    handleSearchableSelectChange = (e, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (name === 'customer_id') {
            const customer = this.props.customers.find((customer) => customer.id === e.value);

            this.setState(
                {
                    customer_id: customer,
                    contacts: customer.contacts,
                    uses_purchase_orders: customer.uses_purchase_orders,
                    errors: errorsObject,
                },
                () => {
                    this.loadCustomerData(e.value);
                }
            );
        } else if (name === 'customer_contact_id') {
            const contact = this.state.contacts.find((contact) => contact.id === e.value);
            const customer = this.props.customers.find((customer) => contact.customer_id === customer.id);

            this.setState(
                {
                    price_quoted: contact.quoted_price,
                    [name]: e,
                    errors: errorsObject,
                    department: contact.department,
                    customer_id: customer,
                },
                () => {
                    this.loadCustomerData(customer.id);
                }
            );
        } else {
            this.setState({ [name]: e, errors: errorsObject });
        }
    };

    loadCustomerData = (customerId) => {
        let url = this.props.customerJobsDataUrl.replace(':customer-id', customerId);

        let tyreType = this.props.jobs.find((job) => {
            return job.name === 'Tyres';
        });

        let newState = {};

        //If user has use address flag, set job location data same as customer location data unless user is logged in as customer contact
        if (!this.props.customer_contact) {
            let jobLocationData = this.getJobLocationDataFromCustomer();
            newState = { ...jobLocationData };
        }

        if (this.state.customer_id && this.state.customer_id.uses_purchase_orders && this.state.customer_id.po_number) {
            let poNumber = this.state.customer_id.po_number;
            newState = {
                ...newState,
                purchase_order_number: poNumber,
                disable_po: true,
            };
        } else {
            newState = { ...newState, disable_po: false };
        }

        let extrasOptions = {};

        $.ajax({
            url: url,
            data: {},
            dataType: 'json',
            type: 'GET',
            success: (response) => {
                extrasOptions.jobTypeOptions = response.data.jobTypes;
                extrasOptions.jobExtrasOptions = response.data.jobExtras;
                extrasOptions.gardeningExtrasOptions = response.data.gardeningExtras;
                extrasOptions.tyreTypesOptions = response.data.tyreTypes;
                extrasOptions.extrasOptions =
                    this.state.job_type === 'tyres' ? response.data.tyreTypes : response.data.jobExtras;
                extrasOptions.wasteBagExtrasOptions = response.data.wasteBagExtras;
                extrasOptions.skipHireExtrasOptions = response.data.skipHireExtras;

                newState = { ...extrasOptions, ...newState };
                this.setState(newState);
            },
            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
            },
        });
    };

    isWeekday = (date) => {
        const day = new Date(date).getDay();
        return day !== 0 && day !== 6;
    };

    handleExtras = () => {
        const tyreType = this.props.jobs.filter((el) => {
            return el.name === 'Tyres';
        })[0];

        if (this.state.customer_id) {
            this.loadCustomerData(this.state.customer_id.id);
        }
        if (tyreType && tyreType !== 'undefined') {
            this.setState({
                extrasOptions:
                    this.state.job_type === 'tyres' ? this.state.tyreTypesOptions : this.state.jobExtrasOptions,
            });
        }
    };

    handleJobTypeChange = (job_type_id) => {
        let job_type = this.props.jobs.find((jobType) => {
            return jobType.id === Number(job_type_id);
        });
        job_type = typeof job_type !== 'undefined' ? job_type.name.toLowerCase() : null;
        this.setState({
            extrasOptions: job_type === 'tyres' ? this.state.tyreTypesOptions : this.state.jobExtrasOptions,
            selectedExtras: [],
            selectedGardeningExtras: [],
            selectedWasteBagExtras: [],
            selectedSkipHireExtras: [],
            showGardeningExtras: job_type === 'gardening' || job_type.includes('void'),
            showWasteBagExtras: job_type === 'waste bag',
            showSkipHireExtras: job_type === 'skip hire',
        });
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (moment(date).isValid()) {
            this.setState({ [name]: date, errors: errorsObject });
        } else {
            this.setState({ [name]: null });
        }
    };

    onDrop = (acceptedFiles) => {
        let oldFiles = [...this.state.acceptedFiles];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            acceptedFiles: files,
        });
    };

    removeFile = (file, index) => {
        let acceptedFiles = [...this.state.acceptedFiles];
        acceptedFiles.splice(index, 1);
        this.setState({ acceptedFiles });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    getJobLocationDataFromCustomer = () => {
        let customer = this.state.customer_id;

        if (customer.use_address && !this.state.job_id) {
            let telephone = customer.contacts.find((contact) => {
                return contact.type === 'main';
            }).telephone;

            return {
                address_line_1: customer.address_line_1,
                address_line_2: customer.address_line_2 ? customer.address_line_2 : '',
                postcode: customer.postcode,
                city: customer.city,
                telephone: telephone,
            };
        }
        return {};
    };

    checkIfPoJobExists = () => {
        let formData = new FormData();
        formData.append('job_type_id', this.state.job_type_id);
        formData.append('address_line_1', this.state.address_line_1);
        formData.append('postcode', this.state.postcode);
        if (this.state.job_id) {
            formData.append('job_id', this.state.job_id);
        }

        return axios.post(`/customers/${this.state.customer_id.id}/has-po-job`, formData);
    };

    getCustomerPo = () => {
        return this.state.customer.uses_purchase_orders ? this.state.customer.po_number : null;
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'customer_id',
            'customer_contact_id',
            'address_line_1',
            'postcode',
            'city',
            'job_type_id',
            'date_ready',
            'created_by',
        ];

        if (this.state.price_quoted) {
            fields.push('custom_price');
        }

        if (this.state.recurring && this.state.recurring_interval) {
            fields.push('recurring_interval');
        }

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        if (this.state.postcode && !isValidPostcode(this.state.postcode)) {
            errors.postcode = POSTCODE_FORMAT_ERROR;
        }

        if (
            this.state.recurring &&
            !this.state.recurring_interval &&
            !this.state.recurring_days.some((week_days) => week_days.length > 0)
        ) {
            errors.recurring_days = 'Select at least one recurring day';
        }

        this.setState({ errors: errors, loading: false });

        if (errors.postcode === POSTCODE_FORMAT_ERROR) {
            toastr.error(POSTCODE_FORMAT_ERROR);
        }

        if (Object.values(errors).some((error) => error !== POSTCODE_FORMAT_ERROR)) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };
    onSubmitValidate = (e) => {
        console.log('Submitting - state.created_by:', this.state.created_by);

        if (this.validateForm()) {
            //  Start spinner flag
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();
            if (this.props.buttonText === 'Create') {
                this.jobService
                    .saveJob(formData, this.props.storeRoute)
                    .then((res) => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.success('This job was successfully created.');
                        window.location.href = '/jobs';
                    })
                    .catch(() => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.error('There was a problem with submitting the form. Please try again.');
                    });
            } else {
                formData.append('_method', 'PATCH');
                this.submitJobUpdate(formData);
            }
        }
    };

    submitJobUpdate = (formData) => {
        this.jobService
            .updateJob(this.state.job_id, formData)
            .then((res) => {
                //  Stop spinner flag
                this.setState({ loading: false });
                toastr.success('This job was successfully edited.');
                window.location.reload();
            })
            .catch((err) => {
                if (err.response && err.response.status === 422 && err.response.data.requires_price_change_reason) {
                    this.promptPriceChangeReason(formData);
                    return;
                }

                //  Stop spinner flag
                this.setState({ loading: false });
                toastr.error('There was a problem with submitting the form. Please try again.');
            });
    };

    promptPriceChangeReason = (formData) => {
        promptForPriceChangeReason().then((reason) => {
            if (!reason) {
                this.setState({ loading: false });
                return;
            }

            formData.set('price_change_reason', reason);
            this.submitJobUpdate(formData);
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.state.excluded_from_sla && !this.state.excluded_from_sla_reason.trim()) {
            this.setState({
                errors: { excluded_from_sla_reason: 'A reason is required to exclude this job from SLA figures.' },
            });
            toastr.error('Please provide a reason for excluding this job from SLA figures.');
            return;
        }

        this.setState({
            errors: {},
            loading: true,
        });

        this.checkIfPoJobExists().then((res) => {
            if (res.data.exists === true) {
                window.swal
                    .fire({
                        title: `Recurring job already exists`,
                        html: `Recurring <a href="${res.data.job_url}" target="_blank">job</a> for this address was already created in the last 7 days`,
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Create job',
                        cancelButtonText: 'Back to job form',
                    })
                    .then((isConfirm) => {
                        if (isConfirm.dismiss) {
                            this.setState({
                                loading: false,
                            });

                            return false;
                        } else if (isConfirm.isDenied) {
                            this.setState({
                                loading: false,
                            });
                            return false;
                        } else if (isConfirm.value) {
                            if (this.state.uses_purchase_orders && !this.state.purchase_order_number) {
                                window.swal
                                    .fire({
                                        title: `Empty purchase order number`,
                                        text: `This customer uses purchase orders, do you want to enter purchase order number?`,
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonText: 'Submit without PO number',
                                        cancelButtonText: 'Enter PO',
                                    })
                                    .then((isConfirm) => {
                                        if (isConfirm.dismiss) {
                                            this.setState({
                                                loading: false,
                                            });
                                            return false;
                                        } else if (isConfirm.value) {
                                            this.onSubmitValidate(e);
                                        }
                                    });
                            } else {
                                this.onSubmitValidate(e);
                            }
                        }
                    });
            } else {
                if (this.state.uses_purchase_orders && !this.state.purchase_order_number) {
                    window.swal
                        .fire({
                            title: `Empty purchase order number`,
                            text: `This customer uses purchase orders, do you want to enter purchase order number?`,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Submit without PO number',
                            cancelButtonText: 'Enter PO',
                        })
                        .then((isConfirm) => {
                            if (isConfirm.dismiss) {
                                this.setState({
                                    loading: false,
                                });
                                return false;
                            } else if (isConfirm.value) {
                                this.onSubmitValidate(e);
                            }
                        });
                } else {
                    this.onSubmitValidate(e);
                }
            }

            return true;
        });
    };

    mapInputsToFormData = () => {
        let formData = new FormData();

        const mappable = [
            'customer_id',
            'customer_contact_id',
            'job_source_id',
            'job_type_id',
            'address_line_1',
            'address_line_2',
            'description',
            'admin_notes',
            'special_requests',
            'postcode',
            'city',
            'telephone',
            'os_contact_name',
            'os_contact_mobile',
            'quantity',
            'extras',
            'date_ready',
            'service_provider_id',
            'job_group',
            'custom_price',
            'recurring_interval',
            'provider_custom_price',
            'execution_date',
            'purchase_order_number',
            'purchase_order_total',
        ];

        // Append files
        this.state.acceptedFiles.forEach((file) => formData.append('files[]', file));

        // Append recurring days (a cycle of weeks, each a list of days) as JSON, preserving
        // deliberately empty weeks; the backend normalizes an all-empty pattern to null.
        formData.append('recurring_days', JSON.stringify(this.state.recurring_days));

        // Append extras as JSON
        formData.append('selected_extras', JSON.stringify(this.state.selectedExtras));
        formData.append('gardening_extras', JSON.stringify(this.state.selectedGardeningExtras));
        formData.append('waste_bag_extras', JSON.stringify(this.state.selectedWasteBagExtras));
        formData.append('skip_hire_extras', JSON.stringify(this.state.selectedSkipHireExtras));

        // Append boolean flags
        formData.append('os_contact_updates', this.state.os_contact_updates ? 1 : 0);
        formData.append('non_stop', this.state.non_stop ? 1 : 0);
        formData.append('two_person_team', this.state.two_person_team ? 1 : 0);
        formData.append('price_quoted', this.state.price_quoted ? 1 : 0);
        formData.append('recurring', this.state.recurring ? 1 : 0);
        formData.append('manager_review', this.state.manager_review ? 1 : 0);
        formData.append('provider_price_quoted', this.state.provider_price_quoted ? 1 : 0);
        formData.append('manager_review_reason', this.state.manager_review_reason);
        formData.append('excluded_from_sla', this.state.excluded_from_sla ? 1 : 0);
        formData.append('excluded_from_sla_reason', this.state.excluded_from_sla_reason);
        formData.append('created_by', this.state.created_by);

        formData.append('purchase_order_total', this.state.purchase_order_total ? this.state.purchase_order_total : 0);
        formData.append(
            'purchase_order_number',
            this.state.purchase_order_number ? this.state.purchase_order_number : null
        );

        // Append SLA if editing
        if (this.state.job_id) formData.append('sla', this.state.sla);

        // Loop through other fields
        mappable.forEach((input) => {
            let value;

            // Handle Select inputs
            if (['customer_id', 'customer_contact_id', 'job_source_id', 'service_provider_id'].includes(input)) {
                value = this.state[input]?.id ?? this.state[input]?.value ?? '';
            }
            // Handle Date inputs
            else if (['date_ready', 'execution_date'].includes(input)) {
                value = this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD') : '';
            }
            // All other inputs
            else {
                value = this.state[input] ?? '';
            }

            console.log(`Appending ${input}:`, value); // Logs the actual value being sent
            formData.append(input, value);
        });

        return formData;
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];
        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];
            if (!extras[extras.length - 1].hasOwnProperty('quantity') || extras[extras.length - 1].quantity === '') {
                extras[extras.length - 1].quantity = 1;
            }
        }
        this.setState({
            [type]: extras,
        });
    };

    handleExtraQtyChange = (e, extra, type, field) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][field] = e.target.value;

        this.setState({
            [type]: extras,
        });
    };

    recreateJob = async (jobId) => {
        try {
            this.setState({ recreatingJob: true });

            const response = await axios.post(`/jobs/${jobId}/recreate-job`);

            window.location.href = `/jobs/${response.data.job_id}/edit`;
        } catch (error) {
            console.error(error);
            alert('Failed to recreate job');
        } finally {
            this.setState({ recreatingJob: false });
        }
    };

    render() {
        return (
            <Fragment>
                {this.props.customer_contact ? (
                    <CustomerCreateJob
                        errors={this.state.errors}
                        buttonText={this.props.buttonText}
                        data={this.state}
                        extrasOptions={this.state.extrasOptions}
                        gardeningExtrasOptions={this.state.gardeningExtrasOptions}
                        wasteBagExtrasOptions={this.state.wasteBagExtrasOptions}
                        skipHireExtrasOptions={this.state.skipHireExtrasOptions}
                        jobs={this.state.jobTypeOptions}
                        customers={this.props.customers}
                        jobSources={this.props.jobSources}
                        onSubmit={this.onSubmit}
                        handleSearchableSelectChange={this.handleSearchableSelectChange}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        myRef={this.myRef}
                        handleChange={this.handleChange}
                        handleDateChange={this.handleDateChange}
                        handleMultiSelectChange={this.handleMultiSelectChange}
                        isWeekday={this.isWeekday}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        createdBy={this.state.created_by}
                    />
                ) : (
                    <AdminCreateJob
                        errors={this.state.errors}
                        buttonText={this.props.buttonText}
                        data={this.state}
                        extrasOptions={this.state.extrasOptions}
                        gardeningExtrasOptions={this.state.gardeningExtrasOptions}
                        wasteBagExtrasOptions={this.state.wasteBagExtrasOptions}
                        skipHireExtrasOptions={this.state.skipHireExtrasOptions}
                        jobs={this.state.jobTypeOptions}
                        customers={this.props.customers}
                        jobSources={this.props.jobSources}
                        onSubmit={this.onSubmit}
                        handleSearchableSelectChange={this.handleSearchableSelectChange}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        myRef={this.myRef}
                        handleChange={this.handleChange}
                        handleRecurringDayToggle={this.handleRecurringDayToggle}
                        addRecurringWeek={this.addRecurringWeek}
                        removeRecurringWeek={this.removeRecurringWeek}
                        handleDateChange={this.handleDateChange}
                        handleJobPrice={this.handleJobPrice}
                        handleMultiSelectChange={this.handleMultiSelectChange}
                        isWeekday={this.isWeekday}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        onExtraWeightChange={this.handleExtraWeightChange}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        disablePo={this.state.disable_po}
                        providers={this.props.providers}
                        execution_date={this.execution_date ? new Date(this.execution_date) : ''}
                        handleProviderJobPrice={this.handleProviderJobPrice}
                        createdBy={this.state.created_by}
                        onRecreateJob={this.recreateJob}
                        recreatingJob={this.state.recreatingJob}
                        currentUser={this.props.currentUser}
                    />
                )}
            </Fragment>
        );
    }
}

if (document.getElementById('jobForm')) {
    let element = document.getElementById('jobForm');
    let customers = element.dataset.customers ? JSON.parse(element.dataset.customers) : false;
    let customer_contact = element.dataset.customer_contact ? JSON.parse(element.dataset.customer_contact) : false;
    let customer_contacts =
        element.dataset.button_text === 'Create' && !customer_contact
            ? JSON.parse(element.dataset.customer_contacts)
            : [];
    let providers = element.dataset.service_providers ? JSON.parse(element.dataset.service_providers) : false;
    let currentUser = element.dataset.current_user ? JSON.parse(element.dataset.current_user) : '';
    console.log(currentUser);
    ReactDOM.render(
        <JobForm
            job={JSON.parse(element.dataset.job)}
            customers={customers}
            jobs={JSON.parse(element.dataset.jobs)}
            jobSources={JSON.parse(element.dataset.job_sources)}
            customer_contact={customer_contact}
            storeRoute={element.dataset.store_route}
            buttonText={element.dataset.button_text}
            customerJobsDataUrl={element.dataset.customer_jobs_data_url}
            customerContacts={customer_contacts}
            providers={providers}
            currentUser={currentUser}
        />,
        element
    );
}

export default JobForm;
